import { useEffect, useState } from "react";
import { Medal, CalendarRange } from "lucide-react";
import { api } from "@/lib/api";
import { UserAvatar, UserLink } from "@/components/UserBits";

const NAMES = { saskia: "Team Saskia", stefan: "Team Stefan" };

export function TeamRecords() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/team/records").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <section className="space-y-3" data-testid="team-records">
      <div><h2 className="font-display text-2xl font-extrabold">Team-Rekorde</h2><p className="text-sm text-slate-500">Gezählt wird seit Start der Rekorde – jeder Punkt zählt für das Team, in dem man ihn geholt hat.</p></div>
      <div className="grid sm:grid-cols-2 gap-4">
        {Object.keys(NAMES).map((t) => (
          <div key={t} className="bg-white rounded-3xl border border-pink-100 p-5 space-y-4" data-testid={`team-records-${t}`}>
            <p className="font-display text-lg font-extrabold">{NAMES[t]}</p>
            <div>
              <p className="text-xs font-bold text-slate-500 flex items-center gap-1.5 mb-2"><CalendarRange className="w-3.5 h-3.5 text-rose-500" /> Beste Wochen</p>
              {d[t].weeks.length === 0 ? <p className="text-sm text-slate-400">Noch keine Rekorde.</p> : (
                <ol className="space-y-1.5">{d[t].weeks.map((w, i) => <li key={w.week} className="flex justify-between text-sm" data-testid={`team-best-week-${t}-${i}`}><span className="font-semibold">{i + 1}. {w.week}</span><span className="font-extrabold text-rose-600">{w.points.toLocaleString("de-DE")}</span></li>)}</ol>
              )}
            </div>
            <div>
              <p className="text-xs font-bold text-slate-500 flex items-center gap-1.5 mb-2"><Medal className="w-3.5 h-3.5 text-amber-500" /> Größte Punktesammler aller Zeiten</p>
              {d[t].top.length === 0 ? <p className="text-sm text-slate-400">Noch niemand.</p> : (
                <ol className="space-y-2">{d[t].top.map((x, i) => (
                  <li key={x.user.user_id} className="flex items-center gap-2 text-sm" data-testid={`team-alltime-${t}-${i}`}>
                    <span className="w-4 text-xs font-bold text-slate-400">{i + 1}</span>
                    <UserAvatar userId={x.user.user_id} name={x.user.name} picture={x.user.picture} size="w-7 h-7" text="text-xs" crown={false} />
                    <UserLink id={x.user.user_id} className="flex-1 min-w-0 truncate font-semibold">{x.user.name}</UserLink>
                    <span className="text-xs font-extrabold text-rose-600">{x.points.toLocaleString("de-DE")}</span>
                  </li>
                ))}</ol>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
